<template>
  <div id="academic_doubleMajors">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>
    <usc-intro :copy="this.intro"></usc-intro>

    <div class="body gutter-lg mb">
      <p><i>Whether you are simply interested in learning more about a particular subject or have a specific career goal in mind, pursuing a minor or double major can enrich your educational experience and set you up for lifelong learning as well as professional success.</i></p>
      <img src="../../../static/customize-your-degree-24.png" style="width: 100%;" alt="Infographic: 33% Marshall students who pursue a double major or minor. 200+ Majors. 250 Minors" title="Infographic: 33% Marshall students who pursue a double major or minor. 200 Majors. 200+ Minors"/>
    </div>

    <div class="body gutter-lg mb">
      <h2>Examples of Minors and Double Majors for Business and Accounting Students:</h2>
      <h4>Minor or double major in Psychology</h4>
      <p>Students interested in marketing need to understand what attracts customers to certain products, ad campaigns or marketing strategies. A background in psychology will help you understand how to influence consumers’ decisions and give you an edge in the marketplace.</p>

      <h4>Minor in Natural Sciences</h4>
      <p>If you’re considering attending medical school after graduation, you can satisfy all of the science requirements for admission to medical school by completing the Natural Sciences minor. The combination of an undergraduate business degree and medical degree can position you for success in opening your own medical practice or working in hospital administration.</p>

      <h4>Minor in a Foreign Language</h4>
      <p>Anyone interested in working overseas or for a global company with international offices or clients will benefit from becoming bilingual or conversant in another language.</p>

      <h4>Minor in Professional and Managerial Communication</h4>
<p>Hone your communication skills—an advantage in any business venture, especially in leadership positions.</p>

<h4>Minor or Double Major in International Relations</h4>
<p>Gain an advantage toward a career in international business, public diplomacy, government position overseas or any role that requires global and negotiation skills.</p>





      <!-- <usc-cta text="Find your minor here" url="https://undergrad.usc.edu/programs/minor/list/"></usc-cta> -->


    </div>
    <usc-listImage>
      <h3 slot="title">Double Majors and Dual Degrees</h3>
      <p slot="body">Many Marshall students pursue a double major. Among the most common are:</p>
      <li slot="item">Accounting</li>
      <li slot="item">Economics</li>
      <li slot="item">Psychology</li>
      <li slot="item">Political Science</li>
      <li slot="item">Biological Sciences (B.A.)</li>
      <li slot="item">East Asian Languages and Cultures</li>
      <li slot="item">International Relations</li>
      <li slot="item">Music Industry</li>
      <li slot="item">Neuroscience</li>
      <li slot="item">Philosophy</li>
      <li slot="item">Public Policy, Management and Planning</li>
      <!-- <li slot="item"></li> -->
      <img slot="img" alt="" src="/static/Academics_Double_Major-listimg.jpg" />
    </usc-listImage>
    <div class="body gutter-lg mb">
      <usc-cta text="Explore double majors" url="https://academics.usc.edu/"></usc-cta>
    </div>
    <usc-listImage>
      <h3 slot="title">Minors</h3>
      <p slot="body">Frequent minors completed by Marshall students include:</p>
      <li slot="item">Cinematic Arts</li>
      <li slot="item">Psychology</li>
      <li slot="item">Economics</li>
      <li slot="item">International Relations</li>
      <li slot="item">Music Industry</li>
      <li slot="item">Spanish</li>
      <li slot="item">Communication &amp; the Entertainment Industry</li>
      <li slot="item">Real Estate Development</li>
      <li slot="item">Communications Design</li>
      <li slot="item">East Asian Languages and Cultures</li>
      <li slot="item">Natural Sciences</li>
      <li slot="item">Sports Media Studies</li>
      <img slot="img" alt="" src="/static/Academics_Minors.jpg" />
    </usc-listImage>
        <div class="body gutter-lg mb">
            <usc-videoEmbed :frameTitle="this.video1.frameTitle" :caption="this.video1.caption" :videoSource="this.video1.src"></usc-videoEmbed>
          <usc-cta text="Find your minor" url="https://undergrad.usc.edu/programs/minor/list/"></usc-cta>
        </div>
  </div>
</template>

<script>
import hero from '@/components/Hero'
import intro from '@/components/Intro'
import listImage from '@/components/ListImage'
import videoEmbed from '@/components/videoEmbed'
import Cta from '@/components/Cta'

export default {
  name: 'UndergradAccounting',
  components: {
    'usc-hero': hero,
    'usc-intro': intro,
    'usc-videoEmbed': videoEmbed,
    'usc-listImage': listImage,
    'usc-cta': Cta
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Double Majors and Minors',
        loResSrc: '../../../static/HeroImages/Academics5.jpg',
        hiResSrc: '../../../static/HeroImages/Academics5.jpg'
      },
      intro: [
        'USC offers 200+ majors and 250+ minors that can be combined with the Business Administration or Accounting degree to create a unique program tailored to your personal interests and professional aspirations.'
      ],
      video1: {
        caption: 'Double Minors',
        src: 'https://player.vimeo.com/video/249450045?title=0&byline=0&portrait=0',
        frameTitle: 'Double Minors'
      },
      video2: {
        caption: 'Choosing a minor to become an expert in any industry',
        src: 'https://player.vimeo.com/video/249450045?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Customize your education with a minor'
      }
    }
  },
  created () {
    this.$root.setPageHeader('Academics', 'Double Majors and Minors')
  }
}
</script>

<style scoped lang="scss">
  ul {
    margin-left: 1em;
  }
  li {
    margin-left: 1em;
    padding-left: 1em;
    list-style-type: disc;
  }
</style>



// WEBPACK FOOTER //
// src/pages/academics/DoubleMajors.vue